<template>
  <div class="container">
    <!--操作-->
    <el-button v-if="this.is_admin" type="primary" plain size="small" round @click="handleAdd">新增项目</el-button>
    <!--搜索-->
    <search-filter :form-config="searchConfig" :model="query" @search="search" @reset="reset"></search-filter>
    <!--列表-->
    <el-table :loading="loading" :data="tableData" 
      style="width: 100%;border-radius: 10px;" stripe border @row-dblclick="handleEdit">
      <el-table-column border label="项目ID" prop="project_id" min-width="50" show-overflow-tooltip></el-table-column>
      <el-table-column border label="项目名称" prop="project_name" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column border label="社区" prop="sq" show-overflow-tooltip></el-table-column>
      <el-table-column border label="报告标识" prop="bgbs" min-width="60" show-overflow-tooltip></el-table-column>
      <el-table-column border label="项目地址" prop="project_address" show-overflow-tooltip></el-table-column>
      <el-table-column border label="委托单位" prop="client_name" show-overflow-tooltip></el-table-column>
      <el-table-column border label="联系人" prop="client_leader" show-overflow-tooltip></el-table-column>
      <el-table-column border label="联系电话" prop="phone" show-overflow-tooltip></el-table-column>
      <el-table-column border label="项目状态" prop="status" show-overflow-tooltip>
        <template v-slot="scope">
          <el-tag type="primary" size="small">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column border label="创建时间" prop="created_at" show-overflow-tooltip></el-table-column>
      <el-table-column border label="操作" min-width="120" fixed="right">
        <template v-slot="scope">
          <el-button type="text" size="mini" @click="handleDetail(scope.row)">查看</el-button>
          <el-button v-if="is_admin" type="text" size="mini" style="color: red" @click="handleDelete(scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
      :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    <!--对话框-->
    <el-dialog title="新增项目" :visible.sync="addModel.addShow" width="800px" @close="onAddClose">
      <el-form ref="addForm" :model="addModel" label-width="120px" size="small" @close="onEditClose">
        <el-form-item label="项目名称">
          <el-input v-model="addModel.project_name"></el-input>
        </el-form-item>
        <el-form-item label="社区">
          <el-input v-model="addModel.sq"></el-input>
        </el-form-item>
        <el-form-item label="报告标识">
          <el-input v-model="addModel.bgbs" placeholder="如果有社区，报告标识是社区的拼音简写，没有请留空"></el-input>
        </el-form-item>
        <el-form-item label="项目地址">
          <el-input v-model="addModel.project_address"></el-input>
        </el-form-item>
        <el-form-item label="委托单位">
          <el-input v-model="addModel.client_name"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="addModel.client_leader"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="addModel.phone"></el-input>
        </el-form-item>
        <el-form-item label="建筑面积">
          <el-input v-model="addModel.builder_area"></el-input>
        </el-form-item>
        <el-form-item label="受检面积">
          <el-input v-model="addModel.detect_area"></el-input>
        </el-form-item>
        <el-form-item label="建筑高度">
          <el-input v-model="addModel.builder_high"></el-input>
        </el-form-item>
        <el-form-item label="建筑层数">
          <el-input v-model="addModel.builder_floor"></el-input>
        </el-form-item>
        <el-form-item label="使用性质">
          <el-input v-model="addModel.builder_nature"></el-input>
        </el-form-item>
        <el-form-item label="检测部位">
          <el-input v-model="addModel.detect_part"></el-input>
        </el-form-item>
        <el-form-item label="项目人员">
          <el-select v-model="addModel.jc_user_ids" multiple filterable default-first-option placeholder="请选择参加项目的检测人员"
            style="width: 100%">
            <el-option v-for="item in employee_options" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入户率">
          <el-input-number v-model="addModel.rhl" :min="0" :max="100" placeholder="如果没有出租屋请留空"
            style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item style="margin-left:200px;margin-top: 30px">
          <el-button type="primary" @click="onAdd">新增</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="修改项目" :visible.sync="editModel.editShow" width="800px">
      <el-form ref="editForm" :model="editModel" label-width="80px" size="small">
        <el-form-item label="项目名称">
          <el-input v-model="editModel.project_name"></el-input>
        </el-form-item>
        <el-form-item label="社区">
          <el-input v-model="editModel.sq"></el-input>
        </el-form-item>
        <el-form-item label="报告标识">
          <el-input v-model="editModel.bgbs" disabled></el-input>
        </el-form-item>
        <el-form-item label="项目地址">
          <el-input v-model="editModel.project_address"></el-input>
        </el-form-item>
        <el-form-item label="委托单位">
          <el-input v-model="editModel.client_name"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="editModel.client_leader"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="editModel.phone"></el-input>
        </el-form-item>
        <el-form-item label="建筑面积">
          <el-input v-model="editModel.builder_area"></el-input>
        </el-form-item>
        <el-form-item label="受检面积">
          <el-input v-model="editModel.detect_area"></el-input>
        </el-form-item>
        <el-form-item label="建筑高度">
          <el-input v-model="editModel.builder_high"></el-input>
        </el-form-item>
        <el-form-item label="建筑层数">
          <el-input v-model="editModel.builder_floor"></el-input>
        </el-form-item>
        <el-form-item label="使用性质">
          <el-input v-model="editModel.builder_nature"></el-input>
        </el-form-item>
        <el-form-item label="检测部位">
          <el-input v-model="editModel.detect_part"></el-input>
        </el-form-item>
        <el-form-item label="项目状态">
          <el-select v-model="editModel.status" style="width: 100%">
            <el-option value="未开始" label="未开始"></el-option>
            <el-option value="进行中" label="进行中"></el-option>
            <el-option value="已完成" label="已完成"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left:250px;margin-top: 30px">
          <el-button type="primary" @click="onEdit">修改</el-button>
          <el-button type="info" @click="onEditClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Vue from "vue";

export default {
  data() {
    return {
      fileList: [],
      loading: false,
      currentConfig: {},
      tableData: [],
      is_admin: false,
      query: { project_id: "", project_name: "", report_model: "", },
      pagination: { current_page: 1, total: 1, per_page: 10, },
      searchConfig: [
        { key: "project_id", label: "项目ID", type: "input" },
        { key: "project_name", label: "项目名称", type: "input" },
        {
          key: "status",
          label: "项目状态",
          type: "select",
          list: [
            { text: "未开始", value: "未开始" },
            { text: "进行中", value: "进行中" },
            {
              text: "已完成",
              value: "已完成"
            }],
        },
      ],
      addModel: {
        addShow: false,
        project_name: '',
        sq: '',
        bgbs: '',
        rhl: '',
        project_address: '',
        client_name: '',
        client_leader: '',
        phone: '',
        builder_area: '',
        detect_area: '',
        builder_high: '',
        builder_floor: '',
        builder_nature: '',
        detect_part: '',
        jc_user_ids: [],
        jl_user_id: '',
      },
      editModel: {
        editShow: false,
        id: '',
        project_id: '',
        project_name: '',
        sq: '',
        bgbs: '',
        project_address: '',
        client_name: '',
        client_leader: '',
        phone: '',
        status: '',
        builder_area: '',
        detect_area: '',
        builder_high: '',
        builder_floor: '',
        builder_nature: '',
        detect_part: '',
      },
      employee_options: []
    };
  },
  computed: {
    ...mapGetters(['hasPermission']),
  },
  methods: {
    //查看项目详情
    async handleDetail(row) {
      this.$store.commit('SET_PAGE_NUMBER', { projectId: row.project_id, pageNumber: 1 })
      try {
        let res = await this.$Api.post('get_project_permission', { project_id: row.project_id })
        if (res) {
          this.$store.commit('SET_PROJECT_PERMISSION', { role: res })
        }
      } catch (e) {
        this.$message.error('获取项目角色失败')
      }

      this.$router.push({ name: 'project_detail', params: { project_id: row.project_id } })
    },
    //初始化对话框
    initModel(model) {
      Object.keys(model).forEach(key => {
        if (key === 'jc_user_ids') {
          model[key] = []
        } else if (key === 'addShow' || key === 'editShow') {
          model[key] = false
        } else {
          model[key] = ''
        }
      })
    },
    //新增项目
    handleAdd() {
      this.addModel.addShow = true
    },
    async onAdd() {
      await this.$refs['addForm'].validate(async () => {
        try {
          let params = this.addModel
          await this.$Api.post('project', params)
          this.$message.success('新增成功')
          this.initModel(this.addModel)
          await this.getList()
        } catch (e) {
          this.$message.error(e.errormsg)
        }
      });
    },
    onAddClose() {
      this.addModel.addShow = false
      this.initModel(this.addModel)
    },
    //修改项目
    handleEdit(row) {
      this.editModel.editShow = true
      Object.keys(row).forEach(key => {
        if (this.editModel.hasOwnProperty(key)) {
          this.editModel[key] = row[key]
        }
      })
    },
    async onEdit() {
      try {
        let params = this.editModel
        delete params.editShow
        await this.$Api.post('edit_project', params)
        this.$message.success('编辑成功')
        this.initModel(this.editModel)
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onEditClose() {
      this.editModel.editShow = false
      this.initModel(this.editModel)
    },
    //删除
    handleDelete(row) {
      this.$confirm('确认删除?', '确认删除', {
        confirmButtonClass: '确认',
        cancelButtonClass: '取消',
        type: 'warning'
      }).then(
        async () => {
          try {
            await this.$Api.post('project_delete', { 'project_id': row.project_id })
            this.$message.success('删除成功')
            await this.getList()
          } catch (e) {
            this.$message.error(e.errormsg)
          }
        }
      )
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.query = {
        project_code: "",
        project_name: "",
        status_id: "",
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      try {
        let params = {
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("project", { params: params });
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
      } catch (e) {
        this.$message.error(e.errormsg)
      } finally {
        this.loading = false;
      }
    },
    async getEmployeeOptions() {
      try {
        this.employee_options = await this.$Api.get('sys_employee_options')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    }

  },
  created() {
    this.getList();
    this.getEmployeeOptions()
    if (Vue.$Config.userinfo.employee_id === 1) {
      this.is_admin = true
    }
  },
};
</script>
